import type { RatesSettings } from '@/settings/types';

export function effectiveFans(totalFans: number, divisor: number): number {
  if (totalFans <= 0) return 0;
  return totalFans / divisor;
}

export interface FanConsumptionInput {
  watts: number;
  hoursPerDay: number;
  daysPerMonth: number;
  effectiveFans: number;
}

export function fanUnitsPerMonth({
  watts,
  hoursPerDay,
  daysPerMonth,
  effectiveFans,
}: FanConsumptionInput): number {
  return (watts / 1000) * hoursPerDay * daysPerMonth * effectiveFans;
}

export interface FanComparison {
  totalFans: number;
  effectiveFans: number;
  hoursPerDay: number;
  normalUnitsPerMonth: number;
  atombergUnitsPerMonth: number;
  unitsSavedPerMonth: number;
}

export function compareFans(
  totalFans: number,
  hoursPerDay: number,
  rates: RatesSettings,
): FanComparison {
  const eff = effectiveFans(totalFans, rates.fans.effectiveFansDivisor);
  const normal = fanUnitsPerMonth({
    watts: rates.fans.normalWatts,
    hoursPerDay,
    daysPerMonth: rates.fans.daysPerMonth,
    effectiveFans: eff,
  });
  const atomberg = fanUnitsPerMonth({
    watts: rates.fans.atombergWatts,
    hoursPerDay,
    daysPerMonth: rates.fans.daysPerMonth,
    effectiveFans: eff,
  });
  return {
    totalFans,
    effectiveFans: eff,
    hoursPerDay,
    normalUnitsPerMonth: normal,
    atombergUnitsPerMonth: atomberg,
    unitsSavedPerMonth: normal - atomberg,
  };
}
